<div
  class="relative min-h-screen w-full flex items-center justify-center bg-[#0f172a] font-sans overflow-hidden p-6 selection:bg-indigo-500/30 selection:text-white"
>
  <div class="absolute inset-0 z-0 pointer-events-none">
    <div
      class="absolute w-[600px] h-[600px] rounded-full blur-[120px] opacity-40 animate-float top-[-100px] right-[-50px] bg-[radial-gradient(circle,_#4f46e5_0%,_transparent_70%)]"
    ></div>

    <div
      class="absolute w-[500px] h-[500px] rounded-full blur-[100px] opacity-40 animate-float bottom-[-50px] left-[-50px] bg-[radial-gradient(circle,_#9333ea_0%,_transparent_70%)] [animation-delay:-5s]"
    ></div>

    <div
      class="absolute w-[400px] h-[400px] rounded-full blur-[80px] opacity-30 animate-float top-[40%] left-[10%] bg-[radial-gradient(circle,_#0ea5e9_0%,_transparent_70%)] [animation-delay:-10s]"
    ></div>
  </div>

  <app-alert class="fixed top-8 left-0 right-0 px-6 z-50 flex justify-center"></app-alert>

  <div class="relative z-10 w-full max-w-[460px] animate-reveal">
    <div
      class="bg-white/[0.03] backdrop-blur-3xl border border-white/10 rounded-[40px] p-8 md:p-12 shadow-[0_32px_64px_-16px_rgba(0,0,0,0.6)]"
    >
      <div class="text-center mb-10">
        <div
          class="group inline-flex items-center justify-center p-3 bg-white/90 rounded-2xl shadow-2xl mb-6 transition-transform hover:scale-110 duration-500"
        >
          <img
            src="https://ts-space.sgp1.digitaloceanspaces.com/uploads/lottery/admin/image/ae09640b-f4dd-4d6e-89ed-727834ba8d1e-logo.png"
            alt="Logo"
            class="w-12 h-12 object-contain group-hover:rotate-[360deg] transition-transform duration-1000"
          />
        </div>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <div class="space-y-2">
          <label class="block text-sm font-semibold text-slate-300 ml-1">{{ 'login.phone' | translate }}</label>
          <div class="relative group">
            <i
              class="fa-solid fa-phone absolute left-5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-indigo-400 transition-colors duration-300"
            ></i>

            <input type="text" formControlName="phone" [placeholder]="'login.phonePlaceholder' | translate" class="w-full bg-slate-900/50
            border border-white/10 rounded-2xl py-4 pl-[52px] pr-5 text-white text-md transition-all
            duration-300 focus:outline-none focus:border-indigo-500/50 focus:bg-slate-900
            focus:ring-4 focus:ring-indigo-500/10 placeholder:text-slate-600"
            [class.border-red-500/50]="loginForm.get('phone')?.invalid &&
            loginForm.get('phone')?.touched" >
          </div>
          <div
            class="text-red-400/80 text-sm flex items-center gap-1.5 ml-1 animate-reveal"
            *ngIf="loginForm.get('phone')?.invalid && loginForm.get('phone')?.touched"
          >
            <i class="fa-solid fa-circle-exclamation"></i>
            {{ 'login.phoneRequired' | translate }}
          </div>
        </div>

        <div class="space-y-2">
          <div class="flex items-center justify-between ml-1">
            <label class="text-sm font-semibold text-slate-300">{{ 'login.password' | translate }}</label>
          </div>
          <div class="relative group">
            <i
              class="fa-solid fa-lock absolute left-5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-indigo-400 transition-colors duration-300"
            ></i>
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
            [placeholder]="'login.passwordPlaceholder' | translate" class="w-full bg-slate-900/50 border border-white/10 rounded-2xl
            py-4 pl-[52px] pr-12 text-white text-md transition-all duration-300 focus:outline-none
            focus:border-indigo-500/50 focus:bg-slate-900 focus:ring-4 focus:ring-indigo-500/10
            placeholder:text-slate-600"
            [class.border-red-500/50]="loginForm.get('password')?.invalid &&
            loginForm.get('password')?.touched" >
            <button
              type="button"
              (click)="togglePassword()"
              class="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300 transition-colors p-2 rounded-xl hover:bg-white/5"
            >
              <i
                class="fa-solid"
                [class.fa-eye]="!showPassword"
                [class.fa-eye-slash]="showPassword"
              ></i>
            </button>
          </div>
          <div
            class="text-red-400/80 text-sm flex items-center gap-1.5 ml-1 animate-reveal"
            *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
          >
            <i class="fa-solid fa-circle-exclamation"></i>
            <span *ngIf="loginForm.get('password')?.errors?.['required']"
              >{{ 'login.passwordRequired' | translate }}</span
            >
            <span *ngIf="loginForm.get('password')?.errors?.['minlength']">{{ 'login.passwordMin' | translate }}</span>
          </div>
        </div>

        <button
          type="submit"
          [disabled]="loginForm.invalid || isLoading"
          class="group relative w-full py-5 bg-gradient-to-r from-indigo-600 to-violet-600 text-white rounded-2xl text-lg font-bold shadow-2xl shadow-indigo-500/20 hover:-translate-y-1 hover:shadow-indigo-500/30 active:translate-y-0 disabled:opacity-50 disabled:translate-y-0 transition-all duration-300 overflow-hidden flex items-center justify-center gap-4"
        >
          <div
            class="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:animate-shine transition-transform duration-1000"
          ></div>

          <div
            *ngIf="isLoading"
            class="w-5 h-5 border-[3px] border-white/20 border-t-white rounded-full animate-spin"
          ></div>
          <span>{{ isLoading ? ('login.processing' | translate) : ('login.signIn' | translate) }}</span>
          <i
            class="fa-solid fa-arrow-right text-sm group-hover:translate-x-1 transition-transform"
          ></i>
        </button>
      </form>
    </div>
  </div>
</div>
